import { STORAGE_KEYS } from '../sessionConstants';
import { getSessionItem, setSessionItem } from '../sessionManager';

export function getAuthority(str) {
  const authorityString =
    typeof str === 'undefined' && localStorage ? getSessionItem(STORAGE_KEYS.AUTHORITY) : str; // authorityString could be admin, "admin", ["admin"]

  let authority;

  try {
    if (authorityString) {
      authority = JSON.parse(authorityString);
    }
  } catch (e) {
    authority = authorityString;
  }

  if (typeof authority === 'string') {
    return [authority];
  } // preview.pro.ant.design only do not use in your production.
  // preview.pro.ant.design 专用环境变量，请不要在你的项目中使用它。

  if (!authority && ANT_DESIGN_PRO_ONLY_DO_NOT_USE_IN_YOUR_PRODUCTION === 'site') {
    return ['admin'];
  }

  return authority;
}

export function setAuthority(authority) {
  const proAuthority = typeof authority === 'string' ? [authority] : authority;
  setSessionItem(STORAGE_KEYS.AUTHORITY, JSON.stringify(proAuthority));

  // Persist immediately, but notify React/Redux after the current dispatch.
  // changeLoginStatus (a reducer) calls setAuthority; a sync event would
  // re-render BasicLayout → useSelector while the reducer is still running.
  const notify = () => {
    try {
      window.dispatchEvent(new Event('authority-changed'));
    } catch (e) {}
    try {
      const { reloadAuthorized } = require('./Authorized');
      reloadAuthorized();
    } catch (e) {}
  };

  setTimeout(notify, 0);
}
